import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  walletItemsContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    margin: 'auto',
    padding: theme.spacing(1),
  },
  buttonGroup: {
    padding: theme.spacing(1, 0),
    maxWidth: '100%',
    overflowX: 'auto',
  },
  button: {
    fontWeight: 600,
    fontSize: 12,
    flexBasis: 0,
    textTransform: 'none',
    padding: '8px',
    width: '28%',
    minWidth: '28%',
  },
  buttonWrap: {
    display: 'flex',
    flexFlow: 'column wrap',
    width: '100%',
  },
  cardImage: {
    marginRight: 'auto',
    marginBottom: '6px',
    maxHeight: '16px',
    maxWidth: '100%',
    borderRadius: '3px',
  },
  noCardImage: {
    backgroundColor: '#444444',
    minHeight: '16px',
  },
  cardName: {
    fontWeight: 'bold',
    maxWidth: '100%',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  cardNumb: {
    fontStyle: 'normal',
  },
}));

export default useStyles;
